import { render, staticRenderFns } from "./productSetup.vue?vue&type=template&id=553714be&scoped=true"
import script from "./productSetup.vue?vue&type=script&lang=js"
export * from "./productSetup.vue?vue&type=script&lang=js"
import style0 from "./productSetup.vue?vue&type=style&index=0&id=553714be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553714be",
  null
  
)

export default component.exports